/**
 * Component and type used to make a field that auto complete user.
 */
import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import { capitalize } from 'helpers/helpers';
import { styled } from '@mui/material/styles';
import { UserInfoWithIdT, UserT } from 'business/definitions';
import { useTranslation } from 'react-i18next';

export type UserOptionT = Pick<UserT, 'id' | 'email'>;

type AutocompleteProps = {
    onChange: (value: UserOptionT) => void;
    sender: string;
    senderId: number;
    allUsers: UserInfoWithIdT[];
    disabled: boolean;
};

const StyEmailTextField = styled(TextField, {
    name: 'StyEmailTextField',
})({
    marginLeft: '0.5rem',
    minWidth: '17rem',
});

export const AutocompleteUsers: React.FC<AutocompleteProps> = ({
    onChange,
    sender,
    senderId,
    allUsers,
    disabled,
}) => {
    const { t } = useTranslation();
    const selected: UserOptionT = {
        id: senderId,
        email: sender,
    };

    const getUserOptions = (users: UserInfoWithIdT[]): UserOptionT[] =>
        users.map((user) => ({
            id: user.id,
            email: user.email,
        }));

    const handleChange = (value: UserOptionT | null) => {
        if (value === null) return;
        onChange(value);
    };

    return (
        <Autocomplete
            id="user"
            disabled={disabled}
            options={getUserOptions(allUsers)}
            getOptionLabel={(option: UserOptionT) => option.email}
            value={selected}
            freeSolo={false}
            onChange={(event, value) => handleChange(value)}
            noOptionsText={t('sendDashboard.senderMustBeMantyUser')}
            renderInput={(params) => (
                <StyEmailTextField
                    {...params}
                    label={capitalize(t('sendDashboard.sender'))}
                />
            )}
        />
    );
};
